import axios from 'axios'
import _URL from '../../URL/index';
const limit = 15

export default {
    services: {
        uploadPicture: (form) => {
            return axios.post(`${_URL._API}/picture/upload`, form);
        }
    }
}